import Input, { InputType } from 'components/shared/inputs/input'
import useTranslation from 'utils/hooks/useTranslation'
import * as dd from 'constants/dropdown'
import { convertToSelect } from 'utils'
import { useEffect } from 'react'

type HeatModeDeperditionsConnuesProps = {
  control: any
  errors: any
  calculateDeperd: () => void
  watch?: any
}

const HeatModeDeperditionsConnues: React.FC<HeatModeDeperditionsConnuesProps> = (props) => {
  const { t } = useTranslation()
  const temperatures = convertToSelect(dd.temperature)
  const [temp, dep] = props.watch(['heatMode.deperditions.temperature', 'heatMode.deperditions.deperditions']) //NOSONAR

  useEffect(() => {
    props.calculateDeperd() //NOSONAR
  }, [temp, dep]) //NOSONAR

  return (
    <>
      <group data-gap="20" data-space="10" data-space-left='0'>
        <group data-length='forcefit' data-fit="1" data-max-length="275">
          <Input
            dataLength="autofit"
            type={InputType.Number}
            control={props.control}
            name="heatMode.deperditions.deperditions"
            label={`${t('YOUR_LOSS')} (W)`}
            translateLabel={false}
            size="large"
            requiredLabel={true}
          //placeholder={`${t('YOUR_LOSS')} (W)`}
          />
        </group>
      </group>


    </>
  )
}

export default HeatModeDeperditionsConnues
